import supHttps from '../init/supHttps';

//DATA-01 : Upload complete content of blog
export async function blogUploadFun(data) {
    const result = await supHttps.post(`/data/blog`, data);
    return result;
}

//DATA-02 : Upload content of dropdown
export async function dropdownUploadFun(data) {
    const result = await supHttps.post(`/data/dropdown`, data);
    return result;
}

//DATA-03 : Edit blog
export async function blogEditFun(blogId, data) {
    const result = await supHttps.patch(`/data/blog/${blogId}`, data);
    return result;
}

//DATA-03 : Edit dropdown
export async function dropdownEditFun(dropdownId, data) {
    const result = await supHttps.patch(`/data/dropdown/${dropdownId}`, data);
    return result;
}

//DATA-05 : Delete blog based on the blogId
export async function blogDeleteFun(blogId) {
    const result = await supHttps.delete(`/data/blog/${blogId}`);
    return result;
}

//DATA-06 : Delete blog based on the dropdownId
export async function dropdownDeleteFun(dropdownId) {
    const result = await supHttps.delete(`/data/dropdown/${dropdownId}`);
    return result;
}

//DATA-07 : Upload content of offer
export async function offerUploadFun(data) {
    const result = await supHttps.post(`/data/offer`, data);
    return result;
}

//DATA-08 : Upload content of offer
export async function offerEditFun(offerId, data) {
    const result = await supHttps.patch(`/data/offer/edit/${offerId}`, data);
    return result;
}

//DATA-09 : Upload content of faq
export async function faqUploadFun(data) {
    const result = await supHttps.post(`/data/faq`, data);
    return result;
}

//DATA-10 : Upload content of faq
export async function faqEditFun(faqId, data) {
    const result = await supHttps.patch(`/data/faq/${faqId}`, data);
    return result;
}

//DATA-11 : Delete faq based on the faqId
export async function faqDeleteFun(faqId) {
    const result = await supHttps.delete(`/data/faq/${faqId}`);
    return result;
}

//DATA-12 : Upload content of filter
export async function filterUploadFun(data) {
    const result = await supHttps.post(`/data/filter`, data);
    return result;
}

//DATA-13 : Edit filter
export async function filterEditFun(filterId, data) {
    const result = await supHttps.patch(`/data/filter/${filterId}`, data);
    return result;
}

//DATA-14 : Delete filter based on the filterId
export async function filterDeleteFun(filterId) {
    const result = await supHttps.delete(`/data/filter/${filterId}`);
    return result;
}
